import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { hotjar } from "react-hotjar";
import { Provider } from 'react-redux';
import { store } from './services/store/store';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';
if (process.env.NODE_ENV === 'production') {
    hotjar.initialize({ id: 560365, sv: 6 });
}
const Init = () => {
    const [isReady, setIsReady] = useState(process.env.NODE_ENV !== 'development');
    useEffect(() => {
        if (process.env.NODE_ENV === 'development') {
            import('./mocks/rest/browser')
                .then(({ worker }) => worker.start({
                onUnhandledRequest(req, print) {
                    const excludedRoutes = [
                        'hotjar.com',
                        'youtube.com',
                        'hot-update',
                        'app.min.js',
                        'manifest.json',
                        'hotjar-560365.js',
                        '/api/media/public/landing_page',
                        '/log/',
                        'content/injected',
                        '/static/media/',
                    ];
                    const url = new URL(req.url);
                    const isExcluded = excludedRoutes.some(route => url.origin.includes(route) ||
                        url.pathname.includes(route) ||
                        url.pathname.endsWith('.png'));
                    if (isExcluded) {
                        return;
                    }
                    print.warning();
                },
                serviceWorker: {
                    url: `/mockServiceWorker.js`
                }
            }))
                .then(() => setIsReady(true))
                .catch(err => {
                console.error('Failed to start the worker:', err);
                setIsReady(true); // or handle the error state differently
            });
        }
    }, []);
    if (!isReady) {
        return _jsx("div", { children: "Loading..." }); // Placeholder for loading state
    }
    return (_jsx(Provider, { store: store, children: _jsx(React.StrictMode, { children: _jsx(App, {}) }) }));
};
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(_jsx(Init, {}));
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
